'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createHashHistory');
module.exports = require('./index.js').createHashHistory;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-dom/~/history/createHashHistory.js
 ** module id = 1897
 ** module chunks = 0
 **/